import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';
import { environment } from '../../../environments/environment';

export const cryptoApiInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.cryptoApiUrl)) {
    return next(req);
  }

  const auth = inject(AuthService);
  const token = auth.token();
  const headers: Record<string, string> = { 'X-API-Key': environment.cryptoApiKey };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return next(req.clone({ setHeaders: headers }));
};
